export default function count(array) {
    return array.length;
}
